export default __webpack_public_path__ + "static/media/Savior's Spetum.39711367.jpg";